// React
import { createContext } from "react"

// Types
import type { ContextType } from "../types"

export const DeleteContext = createContext<ContextType>({
  data: {
    file_description: "",
    file_name: "",
    status: 0,
    transaction_date: ""
  },
  refetch: () => {}
})